import { Card, CardGrid, CardHeader, CardContent, CardFooter } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

/** Loading cards use the same grid and anatomy as the list they replace. */
export default function CardSkeleton({ count = 6 }) {
  return (
    <div role="status" aria-label="Loading items">
      <CardGrid aria-hidden="true">
        {Array.from({ length: count }, (_, i) => (
          <Card key={i} stretch>
            <CardHeader className="flex-row items-center justify-between gap-3 space-y-0 pb-3">
              <Skeleton className="h-5 w-2/3" />
              <Skeleton className="size-8 shrink-0 rounded-control" />
            </CardHeader>
            <CardContent className="space-y-2 pb-4">
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-2/3" />
            </CardContent>
            <CardFooter hairline className="justify-between gap-3 py-3">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-3 w-24" />
            </CardFooter>
          </Card>
        ))}
      </CardGrid>
    </div>
  )
}
